/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Title_2Inputs */

const en_wb_marketing_title_2 = /** @type {(inputs: Wb_Marketing_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first draft is there.`)
};

const lv_wb_marketing_title_2 = /** @type {(inputs: Wb_Marketing_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pirmais melnraksts ir gatavs.`)
};

/**
* | output |
* | --- |
* | "The first draft is there." |
*
* @param {Wb_Marketing_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_title_2 = /** @type {((inputs?: Wb_Marketing_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_title_2(inputs)
	return en_wb_marketing_title_2(inputs)
});